import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Col, Row } from 'antd';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { ProductRegistration } from '@app/components/apps/ProductRegistration/ProductRegistration';
import { Route } from 'antd/lib/breadcrumb/Breadcrumb';

export const EditAppeal: React.FC = () => {
  const location = useLocation();
  const { id, related_id, related_code } = location.state || {};
  const [previousCode] = useState<string>(related_code || '');
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('Edit Product Registration Appeal');
  const { setBreadcrumb, clearHeaderButtons } = useHeader();
  const category_id = Number(localStorage.getItem('selected_category_id'));
  const category_name = localStorage.getItem('selected_category_name') || '';

  const routes = [
    { path: 'pr-categories', breadcrumbName: 'Product Registrations' },
    { path: '/product-registrations', breadcrumbName: category_name || 'Product Registrations' },
    previousCode
      ? {
          path: '/view-product-registrations',
          breadcrumbName: previousCode,
          state: { id: related_id },
        }
      : null,
    {
      path: '/edit-product-registrations-appeal',
      breadcrumbName: currentBreadcrumName,
    },
  ].filter((route): route is Route => route !== null);

  useEffect(() => {
    console.log('In Edit Appeal Page');
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, currentBreadcrumName]);

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <ProductRegistration
            type={'edit'}
            editable={true}
            id={id}
            pageTitle={`Edit Product Registration Appeal`}
            setCurrentBreadcrumName={setCurrentBreadcrumName}
          />
        </Col>
      </Row>
    </>
  );
};

export default EditAppeal;
